module.exports = __webpack_public_path__ + "static/media/Blue_Medium.33189d31.webp";